import { AxiosPromise } from "axios";

import { get } from "@/shared/api/apiInstance";

export interface ProfileResponse {
  funders: {
    funderId: string;
    profile: {
      name: string;
      isAllowedToManageContracts: boolean;
      unreadMessagesCount: number;
    };
  }[];
}

export default function getProfile(): AxiosPromise<ProfileResponse> {
  return get("/me");
}
